import { useIonRouter, UseIonRouterResult } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'

export const useGoBack = (defaultAddress?: string) => {
	const nav: UseIonRouterResult = useIonRouter()

	return () => {
		if (nav.canGoBack()) {
			nav.goBack()
		} else {
			nav.push(defaultAddress ?? ROUTES.overall.main, 'back', 'replace')
		}
	}
}
